import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, isRef as _isRef } from "vue"

const _hoisted_1 = { class: "flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:p-0" }
const _hoisted_2 = { class: "inline-block align-bottom rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden transform transition-all sm:my-8 sm:align-middle w-screen h-full sm:p-6" }
const _hoisted_3 = { class: "aspect-6/14 w-full rounded-lg" }
const _hoisted_4 = ["src"]

import { PropType } from 'vue';
import {
  Dialog, DialogOverlay, TransitionChild, TransitionRoot,
} from '@headlessui/vue';
import {
  Carousel, Slide, Pagination, Navigation,
} from 'vue3-carousel';
import { useVModel, onKeyStroke } from '@vueuse/core';


export default /*#__PURE__*/_defineComponent({
  props: {
  open: {
    type: Boolean,
    required: true,
  },
  mediaUrls: {
    type: Array as PropType<string[]>,
    required: true,
  },
  currentSlide: {
    type: Number,
    required: false,
    default: () => 0,
  },
},
  emits: ['update:open', 'update:currentSlide'],
  setup(__props, { emit }) {

const props = __props



const opens = useVModel(props, 'open', emit);
const currentSlides = useVModel(props, 'currentSlide', emit);

onKeyStroke('ArrowRight', (e) => {
  e.preventDefault();
  currentSlides.value += 1;
});

onKeyStroke('ArrowLeft', (e) => {
  e.preventDefault();
  currentSlides.value -= 1;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(TransitionRoot), {
    as: "template",
    show: __props.open
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(Dialog), {
        as: "div",
        "auto-reopen": "true",
        class: "fixed z-10 inset-0 overflow-y-auto",
        onClose: _cache[1] || (_cache[1] = ($event: any) => (opens.value = false)),
        id: "lightbox-el"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_unref(TransitionChild), {
              as: "template",
              enter: "ease-out duration-300",
              "enter-from": "opacity-0",
              "enter-to": "opacity-100",
              leave: "ease-in duration-200",
              "leave-from": "opacity-100",
              "leave-to": "opacity-0"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(DialogOverlay), { class: "fixed inset-0 bg-black bg-opacity-100 transition-opacity" })
              ]),
              _: 1
            }),
            _createVNode(_unref(TransitionChild), {
              as: "template",
              enter: "ease-out duration-300",
              "enter-from": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
              "enter-to": "opacity-100 translate-y-0 sm:scale-100",
              leave: "ease-in duration-200",
              "leave-from": "opacity-100 translate-y-0 sm:scale-100",
              "leave-to": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  _createVNode(_unref(Carousel), {
                    modelValue: _unref(currentSlides),
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(currentSlides) ? currentSlides.value = $event : null)),
                    "items-to-show": 1,
                    "wrap-around": true
                  }, {
                    addons: _withCtx(({ slidesCount }) => [
                      (slidesCount > 1)
                        ? (_openBlock(), _createBlock(_unref(Navigation), { key: 0 }))
                        : _createCommentVNode("", true),
                      (slidesCount > 1)
                        ? (_openBlock(), _createBlock(_unref(Pagination), { key: 1 }))
                        : _createCommentVNode("", true)
                    ]),
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.mediaUrls, (media) => {
                        return (_openBlock(), _createBlock(_unref(Slide), { key: media }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_3, [
                              _createElementVNode("img", {
                                src: media,
                                alt: "post.heading",
                                class: "object-center object-cover rounded-lg"
                              }, null, 8, _hoisted_4)
                            ])
                          ]),
                          _: 2
                        }, 1024))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ])
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["show"]))
}
}

})